export default "__VITE_ASSET__DSh8v4B1__"